<template>
	<!-- <div class="content-settings__box content-settings__box--center outer"> -->
	<transition-group name="imagelist" tag="div" class="content-settings__box content-settings__box--center outer">
		<!-- <img :src="unitlist.items[unitlist.selected].Image" alt=""> -->

		<!-- :style="{ 'background-image': 'url(' + item.Image + ')' }" -->
		<div v-if="index === unitlist.selected" v-for="(item,index) in unitlist.items" :key="item.Model" class="bgimage inner" :style="{ 'background-image': 'url(' + item.Image + ')' }"></div>

	</transition-group>
	<!-- </div> -->
</template>
<script>
export default {
	name: 'bg-image',
	props: ['unitlist']
}
</script>
<style lang="scss" scoped>
$yValOffset: 200px;

.outer {
	position: relative;
	overflow: hidden;
	perspective: 550px;
}

.inner {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: 20px;
	padding: 0; // background:red
	backface-visibility: hidden;
	transform-style: preserve-3d;
	transform: translateZ(1em);
	transform-origin: 50% 50%;
}

.imagelist-enter-active {
	transition: all .5s ease; // opacity: 1;
}

.imagelist-leave-active {
	transition: all .5s ease;
}

.imagelist-enter {
	transform: translate3d(0px, $yValOffset,  300px); //rotateY(-90deg); 
}

.imagelist-leave-to
/* .slide-fade-leave-active below version 2.1.8 */

{
	transform: translate3d(0px, -$yValOffset, -300px);// rotateX(180deg);
	opacity: 0;
}
</style>


// WEBPACK FOOTER //
// BgImage.vue?4ce34ddc